module.exports = __webpack_public_path__ + "static/media/vendor_icon.f8759ccb.svg";